import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Checkbox } from '@material-ui/core';
import { TSelectItem } from '../../../types/common';

type TProps = {
  name: any;
  title: string;
  dataList: Array<TSelectItem>;
  onChange?: (event: any) => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      '@media screen and (min-width:600px)': {
        width: 200
      },
      '@media screen and (max-width:600px)': {
        width: 160
      },
      '@media screen and (max-width:450px)': {
        width: 120
      },
      border: '1px solid #808080',
      borderRadius: 5,
      '& .MuiInput-formControl': {
        marginTop: 0
      },
      '& .MuiSelect-selectMenu': {
        height: 0
      }
    },
    inputLabel: {
      transform: 'translate(9px, 9px) scale(1)',
      '&.Mui-focused': {
        color: '#808080'
      },
      color: '#212121'
    },
    noLabel: {
      marginTop: theme.spacing(3),
      border: '1px solid #808080',
      borderRadius: 5
    },
    selectBox: {
      textAlign: 'left',
      fontFamily: 'Arial',
      padding: '0 0 0 10px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  })
);

export const MultipleSelectfield: React.VFC<TProps> = React.memo(
  (props: TProps) => {
    const { name, title, dataList, onChange } = props;
    const classes = useStyles();

    const [selectedItems, setSelectedItems] = React.useState<string[]>([]);

    const { register, control } = useFormContext();

    const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
      setSelectedItems(event.target.value as string[]);
      if (onChange) {
        onChange(event);
      }
    };

    return (
      <FormControl className={classes.formControl} variant='outlined'>
        <Controller
          name={name}
          control={control}
          render={() => (
            <>
              {selectedItems.length > 0 ? null : (
                <InputLabel
                  id='demo-mutiple-checkbox-label'
                  className={classes.inputLabel}
                  shrink={false}
                >
                  {title}
                </InputLabel>
              )}
              <Select
                labelId='demo-mutiple-checkbox-label'
                id='demo-mutiple-checkbox'
                multiple
                {...register(name)}
                onChange={handleChange}
                value={selectedItems}
                input={<Input disableUnderline id='select-multiple-chip' />}
                renderValue={selected => (
                  <div className={classes.selectBox}>
                    {(selected as string[]).join(', ')}
                  </div>
                )}
                MenuProps={{
                  getContentAnchorEl: null, // anchorOrigin, transformOrigin が変更可能になるように元々ポップオーバーの基準となっている要素を解除
                  variant: 'menu',
                  PaperProps: {
                    style: {
                      height: 250,
                      width: 200
                    }
                  }
                }}
              >
                {dataList.map(item => (
                  <MenuItem key={item.label} value={item.label}>
                    <Checkbox checked={selectedItems.includes(item.label)} />
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        />
      </FormControl>
    );
  }
);
